import { getApiBaseUrl } from "../api/client";

export function getBackendOrigin() {
  const base = String(getApiBaseUrl() || "").trim();
  if (!base || base.startsWith("/")) return window.location.origin;
  return base.replace(/\/+$/, "").replace(/\/api\/?$/i, "");
}

export function resolveProductImageUrl(input, fallback = "") {
  const raw = String(input || "").trim();
  if (!raw) return fallback;
  if (/^(https?:\/\/|data:|blob:)/i.test(raw)) return raw;
  if (raw.startsWith("//")) return `${window.location.protocol}${raw}`;

  const origin = getBackendOrigin();
  const normalized = raw.replace(/\\/g, "/");

  if (normalized.startsWith("/files/")) return `${origin}${normalized}`;
  if (normalized.startsWith("files/")) return `${origin}/${normalized}`;
  if (normalized.startsWith("products/")) return `${origin}/files/${normalized}`;
  if (normalized.startsWith("/products/")) return `${origin}/files${normalized}`;
  if (normalized.startsWith("projects/")) return `${origin}/files/${normalized}`;
  if (normalized.startsWith("/projects/")) return `${origin}/files${normalized}`;

  // Registros muy viejos con sólo filename pertenecen a la carpeta legacy.
  if (!normalized.includes("/")) return `${origin}/files/products/${normalized}`;
  if (normalized.startsWith("/")) return `${origin}${normalized}`;
  return `${origin}/${normalized}`;
}

export function getProductImageUrls(product = {}) {
  const candidates = [];

  if (Array.isArray(product.imagesUrls)) candidates.push(...product.imagesUrls);
  if (product.imageUrl) candidates.push(product.imageUrl);

  if (Array.isArray(product.images)) {
    for (const image of product.images) {
      if (!image) continue;
      if (typeof image === "string") candidates.push(image);
      else candidates.push(image.url, image.path, image.filename);
    }
  }

  return Array.from(
    new Set(candidates.map((value) => resolveProductImageUrl(value)).filter(Boolean)),
  );
}
